import { createAction, props } from '@ngrx/store';
import { IQuotation, IQuotationDetail, SendOrderPayload } from '../models/quotes.models';
import { OrderFilter } from 'src/app/shared/helper';
import { PageParams } from 'src/app/shared/models/request';
import { APIResponse } from 'src/app/core/models/api-response';

// get Orders
export const GetOrders = createAction(
  '[ Order ] - GetOrders',
  props<{ page?: PageParams; keyword?: string; filter?: any }>()
);
export const GetOrdersSuccess = createAction(
  '[ Order ] - GetOrders Success ',
  props<{ resp: APIResponse<IQuotation> }>()
);
export const GetOrdersError = createAction('[ Order ] - GetOrders Error');

// get Order by Id
export const GetOrderById = createAction('[ Order ] - GetOrderById', props<{ id: number }>());
export const GetOrderByIdSuccess = createAction(
  '[ Order ] - GetOrderById Success ',
  props<{ order: IQuotationDetail }>()
);
export const GetOrderByIdError = createAction('[ Order ] - GetOrderById Error');

export const SendOrder = createAction('[ Order ] - SendOrder', props<{ data: SendOrderPayload }>());
export const SendOrderSuccess = createAction(
  '[ Order ] - SendOrder Success ',
  props<{ order: IQuotation }>()
);
export const SendOrderFailure = createAction('[ Order ] - SendOrder Failure');

export const SendRFQ = createAction('[ Order ] - SendRFQ', props<{ data: SendOrderPayload }>());
export const SendRFQSuccess = createAction(
  '[ Order ] - SendRFQ Success ',
  props<{ order: IQuotation }>()
);
export const SendRFQFailure = createAction('[ Order ] - SendRFQ Failure');

export const Loading = createAction('[ Order ] - Loading', props<{ loading: boolean }>());

// Update Order Actions (API calls)
export const UpdateOrder = createAction(
  '[ Order ] - UpdateOrder',
  props<{ orderId: number; updates: Partial<IQuotationDetail> }>()
);
export const UpdateOrderSuccess = createAction(
  '[ Order ] - UpdateOrder Success',
  props<{ order: IQuotationDetail }>()
);
export const UpdateOrderError = createAction('[ Order ] - UpdateOrder Error');

// Local State Management - Update the main order state directly
export const UpdateOrderState = createAction(
  '[ Order ] - UpdateOrderState',
  props<{ updates: Partial<IQuotationDetail> }>()
);

// Reorder
export const Reorder = createAction('[ Order ] - Reorder', props<{ orderId: number }>());
export const ReorderSuccess = createAction(
  '[ Order ] - Reorder Success',
  props<{ order: IQuotationDetail }>()
);
export const ReorderError = createAction('[ Order ] - Reorder Error');

// Filters
export const SetOrderFilter = createAction(
  '[ Filters ] - SetOrderFilter',
  props<{ keyword: string; advanced: OrderFilter | null }>()
);

// search
export const SetOrderSearch = createAction(
  '[ Search ] - SetOrderSearch',
  props<{ keyword: string }>()
);
